export enum FeedbackSubmissionStatus {
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
}

export type FeedbackSubmission = {
  status: FeedbackSubmissionStatus;
  customerRemarks?: string;
  selectedOptionId: string;
};
